import { useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import Accordion from '../../generic/Accordion';
import Button from '../../generic/Button/Button';
import { BUTTON_SIZE } from '../../generic/Button/button-constants';
import Card from '../../generic/Card/Card';
import Flex from '../../generic/Flex';
import type { MalwareReport } from '../../../../shared/model-typings/malwarereport';

import MalwareReportsTable from './MalwareReportsTable';
import ModalMalware from './ModalMalware';

type Props = {
  isOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

const ManualMalwareComponent: VoidFunctionComponent<Props> = ({ isOpen, onToggle }) => {
  const [isSectionOpen, setIsSectionOpen] = useState(isOpen ?? false);
  const handleToggle = () => {
    setIsSectionOpen(!isSectionOpen);
    onToggle?.(isSectionOpen);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMalwareReport, setSelectedMalwareReport] = useState<MalwareReport | undefined>();

  const openAddMalwareDialog = () => {
    setSelectedMalwareReport(undefined);
    setIsModalOpen(true);
  };

  const openEditMalwareDialog = (malwareReport: MalwareReport) => {
    setSelectedMalwareReport(malwareReport);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedMalwareReport(undefined);
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Content>
        <Accordion id="manual-malware" isInitiallyOpen={isSectionOpen}>
          <Accordion.Target onClick={handleToggle}>Manual Malware</Accordion.Target>
          <Accordion.Body>
            <Flex justify="space-between" align="flex-end">
              <Button size={BUTTON_SIZE.MEDIUM} onClick={openAddMalwareDialog}>Add</Button>
            </Flex>
            <MalwareReportsTable onEditMalware={openEditMalwareDialog} />
            <ModalMalware
              show={isModalOpen}
              onHide={closeModal}
              malwareReport={selectedMalwareReport}
            />
          </Accordion.Body>
        </Accordion>
      </Card.Content>
    </Card>
  );
};

export default ManualMalwareComponent;
